import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '1.5rem',
    color: '#323436',
    fontSize: theme.size.sm,
    '& > :nth-child(1)': {
      textTransform: 'capitalize'
    },

    '& > :nth-child(2)': {
      opacity: '0.35',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      paddingBottom: '0.5rem'
    }
  },

  btn: {
    minWidth: 36,
    width: 'auto'
  }
}))

export default useStyles
